import React from 'react';
import { func } from 'prop-types';
import { Button } from 'react-bootstrap';

export default function NotFoundPage({ setPage }) {
  return (
    <div className="text-center">
      <h4 className="margin-topgap40">Something went wrong.</h4>
      <Button onClick={setPage} bsStyle="primary">
        Back
      </Button>
    </div>
  );
}

NotFoundPage.propTypes = {
  setPage: func.isRequired
};
